import { QUERY_PARAMETERS, debounce } from "common/constants"
import {
  dinamicPaginationQuery,
  getInitialPaginationQuery,
  initialPaginationQuery,
  queryCreator,
  removeFromArray,
} from "common/utils/utils"
import { handleCreateQueryConfig } from "features/Validaciones/constants"
import { useCallback, useEffect, useState } from "react"

function useFilters(
  asyncCallback: $TSMigrationFixMe,
  dependencies = [],
  customInitialQuery: $TSMigrationFixMe,
  queryOptions: $TSMigrationFixMe,
  preDataFilter: $TSMigrationFixMe
) {
  const [query, setQuery] = useState(
    `${preDataFilter?.query || customInitialQuery || ""}`
  )
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingMoreData, setLoadingMoreData] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [dataResponse, setDataResponse] = useState({})
  const [selectedOptions, setSelectedOptions] = useState(queryOptions || [])
  const [search, setSearch] = useState(preDataFilter?.search || "")
  const [pagination, setPagination] = useState(
    getInitialPaginationQuery(preDataFilter?.pagination)
  )

  const [selectedMultiple, setSelectedMultiple] = useState(
    preDataFilter?.selectedMultiple || []
  )
  const [error, setError] = useState(null)

  const createQuery = useCallback((selectedOptions: $TSMigrationFixMe) => {
    const parameters = queryCreator(selectedOptions)
    setQuery(parameters)
  }, [])

  const resetPagination = () => {
    getInitialPaginationQuery(preDataFilter?.pagination)
  }

  const handleDataType = (data: $TSMigrationFixMe) => {
    if (data?.items) {
      setData(data.items)
      setTotalCount(data.totalCount)
      setCurrentPage(data.currentPage)
      setDataResponse(data)
    } else {
      setData(data)
    }
  }

  useEffect(() => {
    createQuery(selectedOptions)
  }, [createQuery, selectedOptions])

  const handleFetch = useCallback(async () => {
    const dynamicQuery = `${pagination}${query}${search || ""}`
    try {
      const { data } = await asyncCallback(dynamicQuery)
      handleDataType(data)
    } catch (error) {
      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa...
      setError(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, search, ...dependencies])

  useEffect(() => {
    handleFetch?.()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, pagination, handleFetch, ...dependencies])

  const createQueryArray = useCallback(
    (queryObject: $TSMigrationFixMe) => {
      let newArray = selectedOptions?.slice()
      if (!queryObject.query)
        newArray = removeFromArray(queryObject.key, newArray)
      if (newArray.length === 0) {
        newArray = [...newArray, queryObject]
      } else if (
        newArray.some((obj: $TSMigrationFixMe) => obj.key === queryObject.key)
      ) {
        newArray = newArray.map((obj: $TSMigrationFixMe) =>
          obj.key === queryObject.key ? queryObject : obj
        )
      } else newArray = [...newArray, queryObject]
      setSelectedOptions(newArray)
      return newArray
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedOptions]
  )

  const handleFilter = useCallback(
    (value: $TSMigrationFixMe, queryKey: $TSMigrationFixMe) => {
      let queryParam = ""

      if (value !== undefined) {
        if (!Array.isArray(value)) {
          queryParam = queryKey ? `${queryKey}=${value}` : `${value}`
        } else queryParam = value.join("")
      }
      const queryConfig = handleCreateQueryConfig(queryKey, queryParam)
      createQueryArray(queryConfig)

      return queryConfig
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createQueryArray]
  )

  const handleSetQuery = (queryParam: $TSMigrationFixMe) => {
    setSearch(queryParam)
  }

  const handleSearchDebouce = debounce(handleSetQuery)

  const handleSearch = (
    value: $TSMigrationFixMe,
    queryKey: $TSMigrationFixMe
  ) => {
    const queryParam = value.length ? `${queryKey}=${value}` : ""
    handleSearchDebouce(queryParam)
  }

  const onConfirmFilters = useCallback(
    async (clear: $TSMigrationFixMe, customQuery: $TSMigrationFixMe) => {
      setLoading(true)
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      resetPagination(pagination)
      const confirmedQuery = clear
        ? customQuery
          ? `${initialPaginationQuery}${customQuery}${search}`
          : `${initialPaginationQuery}${search}`
        : customQuery !== undefined
        ? `${pagination}${customQuery}${search}`
        : `${pagination}${query}${search}`

      const { data } = await asyncCallback(confirmedQuery)
      setLoading(false)
      handleDataType(data)
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [asyncCallback, pagination, query, search]
  )

  const handleSetPagination = useCallback(
    (paginationQuery: $TSMigrationFixMe) => {
      setPagination(paginationQuery)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    []
  )

  const handlePaginationQuery = useCallback(
    (event: $TSMigrationFixMe) => {
      if (typeof event === "function") {
        const rangeQuery = `${QUERY_PARAMETERS.MaxResultCount}=${
          event()?.maxResult
        }${QUERY_PARAMETERS.SkipCount}=${event()?.skipCount}`
        handleSetPagination(rangeQuery)
      } else {
        const rangeQuery = `${QUERY_PARAMETERS.MaxResultCount}=${event?.rows}${QUERY_PARAMETERS.SkipCount}=${event?.first}`
        handleSetPagination(rangeQuery)
        setCurrentPage(event?.page + 1)
      }
    },
    [handleSetPagination]
  )

  const resetFilters = useCallback(
    (queryKeys: $TSMigrationFixMe) => {
      if (!queryKeys) {
        setSelectedOptions([])
        setQuery("")
        setSelectedMultiple([])
        // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
        onConfirmFilters(true)
      } else {
        const newSelection = selectedOptions?.filter(
          (option: $TSMigrationFixMe) => !queryKeys.includes(option.key)
        )

        setSelectedOptions(newSelection)
        const parameters = queryCreator(selectedOptions)
        onConfirmFilters(null, parameters)
        setSelectedMultiple([])
      }
    },
    [onConfirmFilters, selectedOptions]
  )

  const handleRemoveFilter = useCallback(
    (queryParam: $TSMigrationFixMe) => {
      const newArray = removeFromArray(queryParam, selectedOptions)
      setSelectedOptions(newArray)
      const parameters = queryCreator(newArray)
      onConfirmFilters(null, parameters)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onConfirmFilters, selectedOptions]
  )

  const handleSelectMultiple = useCallback(
    (selected: $TSMigrationFixMe, queryKey: $TSMigrationFixMe) => {
      let newChecked = selectedMultiple.slice()
      if (
        selectedMultiple.some(
          (option: $TSMigrationFixMe) => option.value === selected.value
        )
      ) {
        newChecked = selectedMultiple.filter(
          (option: $TSMigrationFixMe) => option.value !== selected.value
        )
      } else newChecked = [...selectedMultiple, { ...selected, queryKey }]
      setSelectedMultiple(newChecked)
      const queryMultiple = newChecked
        .filter((option: $TSMigrationFixMe) => option.queryKey === queryKey)
        .map((option: $TSMigrationFixMe) => `${queryKey}=${option.value}`)
        .join("")
      const queryConfig = handleCreateQueryConfig(queryKey, queryMultiple)
      createQueryArray(queryConfig)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [createQueryArray, selectedMultiple]
  )

  const handleComfirmedFilter = (
    value: $TSMigrationFixMe,
    queryKey: $TSMigrationFixMe,
    resetQuery = false
  ) => {
    const queryParam = value ? `${queryKey}=${value}` : ""
    const queryConfig = handleCreateQueryConfig(queryKey, queryParam)
    const query = queryCreator(createQueryArray(queryConfig))
    onConfirmFilters(resetQuery, query)
  }

  const removeExternalQueryFromOptions = (
    externalDefaultQueryArray: $TSMigrationFixMe
  ) => {
    return selectedOptions?.filter((option: $TSMigrationFixMe) => {
      return !externalDefaultQueryArray?.some(
        (initialOption: $TSMigrationFixMe) => initialOption.key === option?.key
      )
    })
  }

  const handlePaginateOnScroll = useCallback(
    async (skipCountValue: $TSMigrationFixMe) => {
      setLoadingMoreData(true)
      const onScrollQuery = `${dinamicPaginationQuery}${skipCountValue}${query}${search}`
      const { data: response } = await asyncCallback(onScrollQuery)
      // @ts-expect-error TS(2345): Argument of type 'any[]' is not assignable to para...
      setData([...data, ...response.items])
      setLoadingMoreData(false)
    },
    [asyncCallback, data, query, search, setLoadingMoreData]
  )

  return {
    handleFilter,
    handleSearch,
    handleRemoveFilter,
    handleSetPagination,
    handleSelectMultiple,
    handleComfirmedFilter,
    handlePaginationQuery,
    handlePaginateOnScroll,
    resetFilters,
    onConfirmFilters,
    removeExternalQueryFromOptions,
    selectedOptions,
    query,
    setQuery,
    search,
    data,
    error,
    loading,
    loadingMoreData,
    totalCount,
    currentPage,
    selectedMultiple,
    dataResponse,
    pagination,
    setSelectedOptions,
    handleFetch,
    setSelectedMultiple,
    resetPagination,
  }
}

export default useFilters
